var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container" }, [
    _c(
      "div",
      { staticClass: "breadcrumb" },
      [
        _c(
          "el-breadcrumb",
          { attrs: { separator: "" } },
          [
            _c("el-breadcrumb-item", [
              _c("div", { staticClass: "div1" }, [_vm._v("基本配置")]),
            ]),
            _vm.judge == "judge"
              ? _c(
                  "el-breadcrumb-item",
                  { attrs: { to: { path: "/staffList" } } },
                  [_c("div", { staticClass: "div3" }, [_vm._v("员工列表")])]
                )
              : _vm._e(),
            _c("el-breadcrumb-item", [
              _c("div", { staticClass: "div2" }, [_vm._v("员工信息")]),
            ]),
          ],
          1
        ),
      ],
      1
    ),
    _c("div", { staticClass: "content" }, [
      _c("p", { staticClass: "header" }, [_vm._v("员工信息")]),
      _c(
        "div",
        { staticClass: "form" },
        [
          _c(
            "el-form",
            { ref: "form", attrs: { model: _vm.form, "label-width": "80px" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "登录名" } },
                [
                  _c("el-input", {
                    attrs: { maxlength: "32" },
                    model: {
                      value: _vm.form.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "name", $$v)
                      },
                      expression: "form.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "中文名" } },
                [
                  _c("el-input", {
                    attrs: { maxlength: "20" },
                    model: {
                      value: _vm.form.chineseName,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "chineseName", $$v)
                      },
                      expression: "form.chineseName",
                    },
                  }),
                ],
                1
              ),
              _vm.judge != "judge"
                ? _c(
                    "el-form-item",
                    { attrs: { label: "用户密码" } },
                    [
                      _c("el-input", {
                        attrs: { maxlength: "64", type: "text" },
                        model: {
                          value: _vm.form.password,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "password", $$v)
                          },
                          expression: "form.password",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                { attrs: { label: "用户类型" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "选择用户类型", clearable: "" },
                      model: {
                        value: _vm.form.perosalaType,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "perosalaType", $$v)
                        },
                        expression: "form.perosalaType",
                      },
                    },
                    _vm._l(_vm.userType, function (items) {
                      return _c("el-option", {
                        key: items.dictId,
                        attrs: { label: items.dictName, value: items.dictId },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "staff" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "所属部门" } },
                    [
                      _c("el-cascader", {
                        attrs: {
                          options: _vm.options,
                          props: {
                            checkStrictly: true,
                            label: "orgName",
                            value: "orgCode",
                            children: "children",
                          },
                          clearable: "",
                          filterable: "",
                        },
                        on: { change: _vm.handleChangeCader },
                        model: {
                          value: _vm.form.staff_position,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "staff_position", $$v)
                          },
                          expression: "form.staff_position",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "职位" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "选择职位类型", clearable: "" },
                          model: {
                            value: _vm.form.position,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "position", $$v)
                            },
                            expression: "form.position",
                          },
                        },
                        _vm._l(_vm.selectType, function (items) {
                          return _c("el-option", {
                            key: items.id,
                            attrs: {
                              label: items.positionName,
                              value: items.positionCode,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "staff" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "数据权限" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: "选择用户的数据权限",
                            clearable: "",
                          },
                          model: {
                            value: _vm.form.dataPermission,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "dataPermission", $$v)
                            },
                            expression: "form.dataPermission",
                          },
                        },
                        _vm._l(_vm.datalist, function (items) {
                          return _c("el-option", {
                            key: items.dictId,
                            attrs: {
                              label: items.dictName,
                              value: items.dictId,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "销售权限" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: "请选择员工销售权限",
                            clearable: "",
                          },
                          model: {
                            value: _vm.form.staff,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "staff", $$v)
                            },
                            expression: "form.staff",
                          },
                        },
                        _vm._l(_vm.list, function (items) {
                          return _c("el-option", {
                            key: items.dictId,
                            attrs: {
                              label: items.dictName,
                              value: items.dictId,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "手机号码" } },
                [
                  _c("el-input", {
                    attrs: { maxlength: "20" },
                    model: {
                      value: _vm.form.phone,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "phone", $$v)
                      },
                      expression: "form.phone",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "联系地址" } },
                [
                  _c("el-input", {
                    staticClass: "address",
                    attrs: { maxlength: "255" },
                    model: {
                      value: _vm.form.address,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "address", $$v)
                      },
                      expression: "form.address",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.addStaff()
                        },
                      },
                    },
                    [_vm._v("保存")]
                  ),
                  !_vm.is_null(_vm.employeeId)
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.limitsSelects },
                        },
                        [_vm._v("添加权限")]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }